import React from 'react';
import { makeStyles, Chip, Tooltip } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return {
        root: {
            padding: '14px 16px',
            borderBottom: 'thin solid #E0E0E0'
        },
        chip: {
            marginRight: '4px',
            marginBottom: '4px'
        }
    };
});
function ChipList(_a) {
    var licenses = _a.licenses, _b = _a.truncateAt, truncateAt = _b === void 0 ? 2 : _b;
    var classes = useStyles();
    var displayLicenses = licenses.slice(0, truncateAt);
    var remainingLicenses = licenses.slice(truncateAt);
    var displayChips = displayLicenses.map(function (license) { return (React.createElement(Chip, { size: "small", className: classes.chip, key: license, label: license })); });
    if (remainingLicenses.length > 0) {
        var title = remainingLicenses.map(function (license) { return license; }).join(', ');
        displayChips.push(React.createElement(Tooltip, { title: title, placement: "top", key: "remaining" },
            React.createElement(Chip, { size: "small", className: classes.chip, label: "+".concat(remainingLicenses.length, " more") })));
    }
    return React.createElement("div", null, displayChips);
}
export default ChipList;
//# sourceMappingURL=ChipList.js.map